import {css} from 'styled-components';
import logoNrk from '../icons/nrk/logo-nrk.png';
import whatsapp from '../icons/sho/whatsapp.png';
import facebook from '../icons/sho/facebook.svg';
import twitter from '../icons/sho/x.svg';
import linkedin from '../icons/sho/linkedin.svg';
import instagram from '../icons/sho/instagram.svg';
import check from '../icons/nrk/check.svg';
import validationError from '../icons/nrk/error.svg';
import buttonIcon from '../icons/nrk/button-icon.svg';

const text = '#646464';
const error50 = '#FFF1F2';
const error300 = '#FF9EA3';
const error500 = '#E8141E';
const error700 = '#A31118';
const error900 = '#4A0508';
const success50 = '#EBFEF4';
const success300 = '#66EFB1';
const success500 = '#00A064';
const success700 = '#008053';
const success900 = '#015338';
const warning50 = '#FFF8ED';
const warning300 = '#FB942D';
const warning500 = '#F97E16';
const warning700 = '#C24A0C';
const warning900 = '#7C3212';
const primary50 = '#FEF3F2';
const primary300 = '#FEA8A3';
const primary500 = '#DC281E';
const primary600 = '#BD2118';
const primary700 = '#9C1F18';
const primary900 = '#821F1A';
const primary950 = '#470B08';
const neutral0 = '#FFFFFF';
const neutral50 = '#EEEEEE';
const neutral100 = '#E7E7E7';
const neutral200 = '#D1D1D1';
const neutral300 = '#B0B0B0';
const neutral400 = '#888888';
const neutral500 = '#6D6D6D';
const neutral600 = '#5D5D5D';
const neutral700 = '#4F5458';
const neutral800 = '#454545';
const neutral900 = '#3D3D3D';
const neutral950 = '#222222';

export default {
  // GlobalStyles
  bodyFontFamily: '"Figtree", "Arial", "sans-serif"',
  h1FontFamily: '"Figtree", "Arial", "sans-serif"',
  h3FontFamily: '"Figtree", "Arial", "sans-serif"',
  h1FontSize: '26px',
  bodyFontSize: '16px',
  letterSpacing: '-0.192px',
  widgetContent: {
    padding: '40px 16px 32px 16px'
  },
  marginBottom: '24px',
  marginBottomStep1: '32px',
  marginBottomTen: '16px',
  headerMarginLeft: '0',
  sidebarMarginLeft: '0',
  horizontalFieldGap: '16px',
  maxWidthContainer: '2200px',
  height: 'auto',
  background: css`
    background-image: ${props => `url('${props.backgroundImageUrl}')`};
    background-repeat: no-repeat;
    background-position: center top;
    background-attachment: fixed;
    background-color: ${neutral50};
    position: fixed;
    top: -10px;
    left: -10px;
    bottom: -10px;
    right: -10px;
    z-index: -10;
    background-size: min(2200px, 100%) !important;

    @media (min-width: 769px) and (max-width: 1024px) {
      background-image: ${props => `url('${props.backgroundImageTabletUrl}')`};
    }

    @media (max-width: 768px) {
      background-image: ${props => `url('${props.backgroundImageMobileUrl}')`};
      background-position: top;
      background-size: contain !important;
      background-attachment: local;
    }
  `,
  hideHeaderMobileStep2: true,
  hideHeaderMobileStep3: true,
  step3HideAmountText: true,
  showRequiredText: true,
  showBsnHelp: true,
  djsb: {
    showDJSBMargin: true,
    smallMobileMarginTop: '95px'
  },
  address: {
    display: 'grid',
    labelDisplay: 'none',
    foundAddressColor: neutral700,
    foundAddressLabelDisplay: 'block',
    noFoundAddressDisplay: 'block',
    foundAddressLabelWeight: '700'
  },
  amountButton: {
    color: success700,
    fontFamily: '"Figtree", Arial, sans-serif;',
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '150%',
    width: '80px',
    height: '48px',
    border: `1px solid ${neutral400}`,
    borderRadius: '5px',
    backgroundColor: '#fff',
    backgroundColorActive: success50,
    borderHover: `3px solid ${success700}`,
    // Ribbon displayed underneath the button (e.g. "Meest gekozen")
    overflow: 'visible',
    ribbonTop: 'calc(100% + 4px)',
    ribbonBottom: 'auto',
    ribbonHeight: 'auto',
    ribbonColor: 'transparent',
    ribbonTextColor: success700,
    ribbonFont: '"Figtree", Arial, sans-serif;',
    ribbonFontSize: '14px',
    ribbonFontWeight: '400',
    ribbonFontStyle: 'italic',
    ribbonLineHeight: '150%',
    ribbonReservedSpace: '25px'
  },
  frequencyButton: {
    color: success700,
    fontFamily: '"Figtree", Arial, sans-serif;',
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '150%',
    width: '171px',
    height: '73px',
    border: `1px solid ${neutral400}`,
    borderRadius: '5px',
    backgroundColor: '#fff',
    backgroundColorActive: success50,
    borderHover: `3px solid ${success700}`,
    // Ribbon (e.g. "Meest gekozen")
    ribbonPosition: 'static',
    ribbonHeight: 'auto',
    ribbonColor: 'transparent',
    ribbonTextColor: success700,
    ribbonFont: '"Figtree", Arial, sans-serif;',
    ribbonFontSize: '14px',
    ribbonFontWeight: '400',
    ribbonLineHeight: '150%'
  },
  buttonContainerSpaceBetween: {
    width: '30%',
    rowGap: '16px',
    gap: '16px',
    width1Buttons: '368px',
    width2Buttons: '176px',
    width3Buttons: '112px',
    width4Buttons: '80px',
    singleRow: true
  },
  paymentMethodsContainer: {
    verticalList: true,
    dividerColor: neutral50,
    rowPadding: '16px 0 16px 30px',
    labelColor: neutral950,
    labelFontSize: '16px',
    labelFontWeight: '400',
    labelLineHeight: '140%',
    logoHeight: '22px',
    headerColor: neutral950,
    headerFontSize: '16px',
    headerFontWeight: '600',
    headerLineHeight: '150%',
    headerMargin: '0 0 8px 0'
  },
  frequencyButtonContainer: {
    width: '30%',
    rowGap: '36px',
    justifyContent: 'space-between'
  },
  //BackButton
  backButton: {
    fontSize: '16px',
    color: neutral700,
    textAlign: 'center'
  },
  // Box
  boxComponent: {
    borderRadius: '4px',
    shadow: '8px 8px 16px 0 rgba(0, 0, 0, 0.15)',
    stickyWithWideTeaser: true,
    stickyTop: '40px',
    stickyBottomGap: '40px'
  },
  // BottomImage
  bottomImage: css`
    margin-top: 32px;
  `,
  // Button
  button: {
    borderRadius: '100px',
    fontFamily: '"Figtree", Arial, sans-serif;',
    fontSize: '16px',
    fontWeight: '600',
    padding: '12px 16px',
    height: '150%',
    backgroundColor: primary500,
    color: '#fff',
    backgroundColorDisabled: neutral100,
    colorDisabled: neutral300,
    borderDisabled: `1px solid ${neutral200}`,
    boxShadow: 'none',
    margin: '32px 0 8px 0',
    display: 'flex',
    justifyContent: 'center',
    gap: '12px',
    transition: 'background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease',
    active: css`
      background-color: ${primary500};
      border-bottom: none;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: ${primary700};
      box-shadow: 0 0 0 3px ${primary950};
    `,
    focus: css`
      box-shadow: none;
    `,
    icon: css`
      display: inline-block;
      height: 24px;
      width: 24px;
      background-color: currentColor;
      mask: url(${buttonIcon}) no-repeat center;
      mask-size: contain;
      -webkit-mask: url(${buttonIcon}) no-repeat center;
      -webkit-mask-size: contain;
      transition: transform 0.3s ease;
    `,
    iconHover: css`
      transform: translateX(4px);
    `
  },
  // Checkbox
  inputCheckbox: {
    width: '20px',
    height: '20px',
    borderRadius: '5px',
    marginLeft: '28px',
    border: `1.25px solid ${neutral300}`,
    label: {
      color: neutral700,
      display: 'block',
      lineHeight: '140%'
    },
  },
  box: {
    fontSize: '16px',
    colorHasError: error700,
    backgroundColorError: error50,
    borderHasError: `1px solid ${error700}`,
    backgroundColorHover: neutral100,
    backgroundColorChecked: neutral700,
    backgroundBorderChecked: 'none',
    checkIconCss: css`
      left: 2.4px;
      top: 4px;
      width: 16px;
      height: 12px;
      background-image: url(${check});
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    `
  },
  // DateInput
  dateDropdown: {
    height: '48px',
    padding: '12px 16px',
    color: neutral500,
    borderRadius: '4px',
    border: `1px solid ${neutral400}`,
    borderHover: `1px solid ${neutral900}`,
    boxShadowHover: `2px 2px 2px 0 rgba(0, 0, 0, 0.05), -2px -2px 2px 0 rgba(0, 0, 0, 0.05), -2px 2px 2px 0 rgba(0, 0, 0, 0.05), -2px 2px 1px 0 rgba(51, 51, 51, 0.05)`,
    borderFocus: `1px solid ${neutral950}`,
    boxShadowFocus: '0 0 3px 1px #222',
    backgroundValid: neutral0,
    borderValid: `1px solid ${neutral700}`,
    colorValid: neutral700,
    borderError: `1px solid ${error500}`,
    backgroundError: error50,
    backgroundColorError: error50,
    colorError: error700,
    chevronSize: '24px',
    chevronTop: '12px'
  },
  // DisplayIban
  iban: {
    fontFamily: '"Figtree", Arial, sans-serif;',
    color: '#fff'
  },
  // Dropdown
  dropdown: {
    height: '48px',
    borderRadius: '4px',
    backgroundColor: '#fff',
    fontSize: '16px',
    paddingLeft: '16px',
    border: `1px solid ${neutral400}`,
    color: neutral500,
    borderHover: `1px solid ${neutral900}`,
    boxShadowHover: `2px 2px 2px 0 rgba(0, 0, 0, 0.05), -2px -2px 2px 0 rgba(0, 0, 0, 0.05), -2px 2px 2px 0 rgba(0, 0, 0, 0.05), -2px 2px 1px 0 rgba(51, 51, 51, 0.05)`,
    borderFocus: `1px solid ${neutral950}`,
    boxShadowFocus: '0 0 3px 1px #222',
    borderValid: `1px solid ${neutral700}`,
    colorValid: neutral700,
    borderError: `1px solid ${error500}`,
    backgroundColorError: error50,
    colorError: error700,
    chevronSize: '24px',
    chevronTop: '12px'
  },
  // ErrorMessage
  error: {
    backgroundColor: error50,
    color: error700,
    width: '100%',
    lineHeight: '24px',
    padding: '8px 4px 8px 12px',
    margin: '0 0 32px 0',
    showBelowBodyText: true
  },
  // Iban
  ibanContainer: {
    display: 'none'
  },
  // Input
  inputComponent: {
    height: '48px',
    borderRadius: '4px',
    fontSize: '16px',
    padding: '12px 16px',
    colorPlaceholder: neutral300,
    color: neutral700,
    border: `1px solid ${neutral400}`,
    borderHover: `1px solid ${neutral900}`,
    boxShadowHover: `2px 2px 2px 0 rgba(0, 0, 0, 0.05), -2px -2px 2px 0 rgba(0, 0, 0, 0.05), -2px 2px 2px 0 rgba(0, 0, 0, 0.05), -2px 2px 1px 0 rgba(51, 51, 51, 0.05)`,
    borderFocus: `1px solid ${neutral950}`,
    boxShadowFocus: '0 0 3px 1px #222',
    borderValid: `1px solid ${neutral700}`,
    borderError: `1px solid ${error500}`,
    colorError: error700,
    backgroundError: error50,
    backgroundColorError: error50,
    backgroundValid: neutral0
  },
  // Paragraph
  paragraph: {
    margin: '8px 0 24px 0',
    fontSize: '16px',
    lineHeight: '150%',
    color: '#757575',
    fontWeight: 'normal'
  },
  // FinalConfirmation
  finalConfirmation: {
    fontSize: '16px',
    lineHeight: '150%',
    color: neutral700,
    fontWeight: 'normal'
  },
  // TextArea
  textAreaComponent: {
    borderRadius: '4px',
    fontSize: '16px',
    padding: '12px 16px',
    colorPlaceholder: neutral300,
    color: neutral700,
    border: `1px solid ${neutral400}`,
    borderHover: `1px solid ${neutral900}`,
    boxShadowHover: `2px 2px 2px 0 rgba(0, 0, 0, 0.05), -2px -2px 2px 0 rgba(0, 0, 0, 0.05), -2px 2px 2px 0 rgba(0, 0, 0, 0.05), -2px 2px 1px 0 rgba(51, 51, 51, 0.05)`,
    borderFocus: `1px solid ${neutral950}`,
    boxShadowFocus: '0 0 3px 1px #222',
    borderValid: `1px solid ${neutral700}`,
    borderError: `1px solid ${error500}`,
    colorError: error700,
    backgroundError: error50,
    backgroundColorError: error50,
    backgroundValid: neutral0
  },
  // Label
  optionalLabel: {
    color: neutral500,
    display: 'none'
  },
  requiredLabel: {
    color: error500,
    display: 'inline'
  },
  label: {
    fontSize: '16px',
    color: neutral950,
    colorError: error500,
    fontWeight: '600',
    lineHeight: '150%',
    marginBottom: '8px'
  },
  subLabel: {
    display: 'block',
    fontSize: '16px',
    color: neutral950,
    colorError: error500,
    fontWeight: '600',
    lineHeight: '150%',
    marginBottom: '8px'
  },
  nameRow: {
    lastNameFlex: '2'
  },
  logo: {
    width: '106px',
    height: '52px',
    backgroundImage: logoNrk,
    widthMobile: '98px',
    heightMobile: '48px',
    margin: '64px 0',
    marginMobile: '32px 0'
  },
  // PartnerTaxDeductible
  partnerTaxDeductible: {
    backgroundColor: neutral50,
    padding: '16px 16px 8px',
    titleFontWeight: '600',
    titleFontSize: '24px',
    titleColor: neutral950
  },
  // PaymentButton
  paymentButton: {},
  // ProgressBar
  progressBar: {
    useProgressSteps: true,
    completedColor: success500,
    activeColor: neutral950,
    inactiveColor: neutral700,
    lineColor: neutral200,
    lineColorCompleted: success500,
    circleSize: '24px',
    checkColor: neutral0,
    fontFamily: '"Figtree", Arial, sans-serif',
    labelFontSize: '14px',
    labelLineHeight: '150%',
    labelFontWeight: '600'
  },
  // RadioButton
  inputRadioButton: {
    height: '20px',
    width: '20px',
    backgroundColor: '#fff',
    labelColor: neutral700,
    border: `1px solid ${neutral300}`,
    backgroundColorHover: neutral100,
    backgroundColorDisabled: neutral100,
    backgroundColorActive: neutral0,
    fillColor: neutral700,
    fillTop: '3px',
    fillLeft: '3px',
    fillWidth: '12px',
    fillHeight: '12px',
    borderActive: `1px solid ${neutral700}`,
    borderDisabled: `1px solid ${neutral300}`,
  },
  radio: {
    colorHasError: error700,
    borderHasError: `1px solid ${error700}`,
    backgroundColorError: error50,
    gap: '40px',
    padding: '0 0 0 30px'
  },
  // TeaserHeader
  teaser: {
    display: 'wide',
    fontFamily: '"Figtree", Arial, sans-serif;',
    fontWeight: '600',
    fontSize: '40px',
    lineHeight: '120%',
    blockBackgroundColor: neutral50,
    color: '#000',
    colorSubtitle: '#000',
    padding: '0 0 calc(80px - 2.5em)',
    paddingLandscapeTablet: '18px 49px calc(80px - 2.5em) 49px',
    paddingTablet: '18px 49px calc(80px - 2.5em) 49px',
    paddingMobile: '80px 16px calc(80px - 2.5em) 16px',
    fontSizeMobile: '24px',
    subtitleFontFamily: '"Figtree", Arial, sans-serif;',
    subtitleFontSize: '16px',
    subtitleLineHeight: '150%',
    subtitleFontSizeWide: '16px',
    subtitleLineHeightWide: '150%',
    subtitleFontSizeTablet: '16px',
    subtitleLineHeightTablet: '150%',
    paddingTop: '0',
    paddingTopSubtitle: '0',
    paddingBottomTitle: '0',
    topLeftTextAlignment: 'left',
    topRightTextAlignment: 'left',
    bottomLeftTextAlignment: 'left',
    bottomRightTextAlignment: 'left',
    shadow: 'none',
    stickyWithWideTeaser: true,
    sidebarMarginTopWide: '60vh',
    stickySidebarTopWide: '82.5vh',
    hideOnStep2: true,
    hideOnStep3: true,
    justifyOutside: true,
    width: '85.8%'
  },
  teaserContainer: {
    margin: '10px 0 0 0'
  },
  teaserCarousel: {
    headerColor: neutral950,
    bodyColor: neutral700
  },
  // Title
  title: {
    color: neutral950,
    fontFamily: '"Figtree", "Arial", "sans-serif"',
    fontSize: '20px',
    height: 'auto',
    fontWeight: '600',
    lineHeight: '130%',
    borderRadius: '4px',
    backgroundColor: neutral50,
    showLogoStep2: true,
    showLogoStep3: true,
    logoMobileOnly: true,
    stickyOnMobile: true,
    showOnThankYou: true
  },
  // Validation
  validation: {
    color: error700,
    fontSize: '16px',
    marginTop: '8px',
    icon: validationError,
    largeIconGap: '10px',
    largeGapMarginLeft: '2px',
    iconGap: '4px'
  },
  // OptIn
  optInButton: {
    fontFamily: '"Figtree", "Arial", "sans-serif"',
    fontSize: '20px',
    backgroundColor: '#4b7382',
    color: '#fff',
    boxShadow: 'none',
    marginBottom: '16px',
    active: css`
      background-color: #4b7382;
      border-bottom: none;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: #4b7382;
    `,
    focus: css`
      box-shadow: none;
    `
  },
  optInDisplay: {
    margin: '0 0 24px 0',
    layout: 'sideBySide',
    sideBySideLabel: {
      color: neutral700,
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '150%'
    }
  },
  // SocialShareButton
  socialShareButton: {
    backgroundSize: '50px',
    color: '#000',
    whatsapp: css`background-image: url(${whatsapp})`,
    facebook: css`background-image: url(${facebook})`,
    twitter: css`background-image: url(${twitter})`,
    linkedin: css`background-image: url(${linkedin})`,
    instagram: css`background-image: url(${instagram})`
  },
  subtleText: {
    color: neutral700,
    fontSize: '14px',
    lineHeight: '150%',
    fontStyle: 'normal'
  },
  telemarketingText: {
    color: neutral700,
    fontSize: '14px',
    lineHeight: '150%'
  },
  telemarketingContainer: {
    marginTop: '8px'
  },
  privacyLabel: {
    standard: {
      color: neutral700,
      lineHeight: '150%'
    }
  },
  faq: {
    borderBottom: `1px solid ${neutral300}`,
    headerFontSize: '24px',
    headerFontWeight: '600',
    headerColor: neutral950,
    headerMargin: '0 0 40px 0',
    padding: '80px 16px',
    questionMargin: '0 64px 0 0',
    questionTextMargin: '24px 0',
    questionFontWeight: '600',
    questionColor: neutral950,
    answerMargin: '0',
    answerTextMargin: '12px 0 0',
    answerColor: neutral700,
    iconFloat: 'right',
    useDropdownIcon: true,
    borderMargin: '12px 0 24px',
    showExpandingAnimation: true
  },
  gridTemplateAreasContainer: '"header header header header header" ". sidebar sidebar content ." ". . . . ." "footer footer footer footer footer"',
  gridTemplateAreasContainerLeft: '"header header header header header" ". content sidebar sidebar ." ". . . . ." "footer footer footer footer footer"',
  gridTemplateColumnsContainer: '96px 1fr 1fr 400px 96px',
  gridTemplateColumnsContainerLeft: '96px 400px 1fr 1fr 96px',
  gridTemplateRows: '200px auto 1fr 100px',

  landscapeTabletGridTemplateRows: '150px auto 1fr auto 100px',
  landscapeTabletGridTemplateColumns: '49px 400px 1fr',
  landscapeTabletGridTemplateAreas: '"header header header" ". djsbMargin ."  ". content ." "sidebar sidebar sidebar" "footer footer footer"',

  tabletGridTemplateRows: '150px auto 1fr auto 100px',
  tabletGridTemplateColumns: '49px 400px 1fr',
  tabletGridTemplateAreas: '"header header header" ". djsbMargin ."  ". content ." "sidebar sidebar sidebar" "footer footer footer"',

  mobileGridTemplateRows: '100px auto 1fr auto 100px',
  mobileGridTemplateRowsStep23: '0px 0px 1fr auto 100px',
  mobileGridTemplateColumns: '1fr',
  mobileGridTemplateAreas: '"header" "djsbMargin" "content" "sidebar" "footer"',

  footerGridTemplateColumns: '96px 400px 1fr 1fr 1fr',
  landscapeTabletFooterGridTemplateColumns: '51px 1fr 144px',
  tabletFooterGridTemplateColumns: '51px 1fr 144px',
  mobileFooterGridTemplateColumns: '16px 1fr 16px'
};
